import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import FilePlusSvg from 'images/v5/icons/file-plus-01.svg';
import Button from 'layout/atoms/Button/Button';
import Card from 'layout/atoms/Card/Card';
import Header from 'layout/atoms/Header/Header';
import Loader from 'layout/atoms/Loader/Loader';
import ComponentCard from 'layout/molecules/ComponentCard/ComponentCard';
import EmptyState from 'layout/molecules/EmptyState/EmptyState';
import Grid from 'layout/molecules/Grid/Grid';
import parseComponentsByCategory from 'parsers/specification/parseComponentsByCategory';
import { parseProductCard } from 'parsers/specification/parseProduct';
import { openModal } from 'store/layoutSlice';
import { fetchSpecificationComponentCards, removeSpecificationComponent, selectSpecificationComponentCards, selectSpecificationComponentCardsRefetch, selectSpecificationComponentCardsSpecificationId, selectSpecificationComponentCardsStatus, shouldFetchSpecificationComponentQuery, } from 'store/specificationComponentsSlice';
import { fetchSpecificationProblems } from 'store/specificationDetailsSlice';
import getCategoryLabel from 'utils/getCategoryLabel';
function Components() {
    const { t, i18n } = useTranslation(['specification', 'common']);
    const dispatch = useDispatch();
    const specificationDetails = useSelector((state) => state.specificationDetails.item);
    const componentsStatus = useSelector(selectSpecificationComponentCardsStatus);
    const componentsRefetch = useSelector(selectSpecificationComponentCardsRefetch);
    const cachedSpecificationId = useSelector(selectSpecificationComponentCardsSpecificationId);
    const components = useSelector(selectSpecificationComponentCards);
    const categoriezdComponents = parseComponentsByCategory(components);
    useEffect(() => {
        if (shouldFetchSpecificationComponentQuery(componentsStatus, componentsRefetch, cachedSpecificationId, specificationDetails.id)) {
            dispatch(fetchSpecificationComponentCards({ specificationId: specificationDetails.id }))
                .unwrap()
                .then(() => {
                dispatch(fetchSpecificationProblems({ specificationId: specificationDetails.id }));
            });
        }
    }, [
        dispatch,
        componentsStatus,
        componentsRefetch,
        cachedSpecificationId,
        specificationDetails.id,
    ]);
    if (cachedSpecificationId !== specificationDetails.id ||
        componentsStatus === 'loading' ||
        componentsStatus === 'idle') {
        return React.createElement(Loader, null);
    }
    if (componentsStatus === 'succeeded' && components.length === 0) {
        return (React.createElement(EmptyState, { header: t('add_first_component'), subheader: t('add_first_component_subheader') },
            React.createElement(Button, { color: "primary", leftIcon: React.createElement(FilePlusSvg, null), onClick: () => dispatch(openModal({ name: 'componentsSelector' })), disabled: specificationDetails.state === 'PRODUCTION' }, t('add_components'))));
    }
    return (React.createElement(Grid, null,
        React.createElement(Header, { size: "m", aside: React.createElement(Button, { color: "primary", leftIcon: React.createElement(FilePlusSvg, null), onClick: () => dispatch(openModal({ name: 'componentsSelector' })), disabled: specificationDetails.state === 'PRODUCTION' }, t('add_components')) }, t('components')),
        categoriezdComponents.map((category) => (React.createElement("div", { key: category.categoryId },
            React.createElement("h3", null, getCategoryLabel(category, i18n)),
            React.createElement(Grid, { columns: "flexible" }, category.items.map((component) => component.productSnapshot ? (React.createElement(ComponentCard, { key: component === null || component === void 0 ? void 0 : component.id, product: parseProductCard(component.productSnapshot.product, i18n), componentId: component.id, onlyActiveVariants: true, deselectable: true, disabled: specificationDetails.state === 'PRODUCTION' })) : (React.createElement(Card, { key: component === null || component === void 0 ? void 0 : component.id },
                React.createElement("p", null, "Unnasigned Component"),
                React.createElement(Button, { color: "primary", onClick: () => dispatch(removeSpecificationComponent({ componentId: component.id })) }, "Delete"))))))))));
}
export default Components;
